import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './axios'
// import manifestJson from "../public/manifest/manifest.json"
import { config } from "jenesius-vue-modal";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
config({
    animation: "fade", // Any name
    
})

const response = await fetch("/manifest/manifest.json"); // مسیر فایل JSON
const manifest = await response.json();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

let app = createApp(App);
app.config.globalProperties = {
    manifest: manifest,
}
app.use(router);
app.component('DatePicker', Vue3PersianDatetimePicker)
app.component('QuillEditor', QuillEditor)
app.use(VueQueryPlugin, { queryClient })
app.mount('#app');
// line 2: Register layouts
